const initialState = {
  loading: false,
};

const emojiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_EMOJI_LOADING":
      return { ...state, loading: true };
    case "ADD_EMOJI_SUCCESS":
      return { ...state, loading: false };
    case "ADD_EMOJI_ERROR":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default emojiReducer;
